export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_ERROR = "LOGIN_ERROR";

export const PEDIDO_ACTUAL = "PEDIDO_ACTUAL";